import React from "react";

import { Tooltip } from "../../tooltip/Tooltip";
import styles from "./FormLabel.module.scss";

interface Props {
  label?: string;
  labelId: string;
  htmlFor: string;
  tooltip?: string;
  fieldName: string;
}

export const FormLabel = ({ label, labelId, htmlFor, tooltip, fieldName }: Props) => {
  if (!label) {
    return null;
  }

  return (
    <div className={styles.formLabel__wrapper}>
      <label id={labelId} htmlFor={htmlFor}>
        {label}
      </label>
      <Tooltip fieldName={fieldName} value={tooltip} />
    </div>
  );
};
